export const transformEmptyStringToNull = (value: string) => (value ? value : null);
